import { axiosWithAuth } from "helpers";

export const companyDocumentsService = {
	getDocuments,
	addDocument,
	viewDocument,
	downloadDocument,
	deleteDocument,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getDocuments(companyId, { page }, sortBy) {
	return axiosWithAuth({
		url: `${API_URL}/api/companies/${companyId}/documents`,
		params: {
			ascending: sortBy?.desc,
			sort_type: sortBy?.id,
			page_index: page,
			page_size: PAGE_SIZE,
		},
	});
}

function addDocument(companyId, document) {
	const formData = new FormData();
	const file = document.file;
	const extension = file.name.split(/[.]+/).pop();

	formData.append("file", file);
	formData.append("name", document.name);
	formData.append("extension", extension);
	formData.append("type", document.type);

	return axiosWithAuth({
		method: "POST",
		data: formData,
		url: `${API_URL}/api/companies/${companyId}/documents`,
		headers: { "Content-Type": undefined },
	});
}

function deleteDocument(companyId, documentId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/companies/${companyId}/documents/${documentId}`,
	};

	return axiosWithAuth(options);
}

function viewDocument(companyId, documentId) {
	try {
		let user = JSON.parse(localStorage.getItem("user") || "");
		window.open(
			`${API_URL}/api/companies/${companyId}/documents/${documentId}/content?token=${user.access_token}`,
			"_blank",
		);
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function downloadDocument(companyId, documentId) {
	try {
		let user = JSON.parse(localStorage.getItem("user") || "");
		const url = `${API_URL}/api/companies/${companyId}/documents/${documentId}/content?download=true&token=${user.access_token}`;
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}
